//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import StreamsDrawerAssetFeedsSetup from '@streams/components/StreamsDrawerAssetFeedsSetup';

angular.module('curalate').component('streamsDrawerAssetFeedsSetup', {
  controller: makeAngularReactController(<StreamsDrawerAssetFeedsSetup/>),
});
